export interface ILoginFormValueTypes {
  email: string;
  password: string;
}

export const InitialLoginFormValues: ILoginFormValueTypes = {
  email: "",
  password: "",
};
